import { Tag } from "@chakra-ui/react";

interface TagStatusProps {
  children: any;
  colorScheme:
    | "whiteAlpha"
    | "blackAlpha"
    | "gray"
    | "red"
    | "orange"
    | "yellow"
    | "green"
    | "teal"
    | "blue"
    | "cyan"
    | "purple"
    | "pink"
    | "linkedin"
    | "facebook"
    | "messenger"
    | "whatsapp"
    | "twitter"
    | "telegram"
    | undefined;
}

export default function TagStatus({ children, colorScheme }: TagStatusProps) {
  return (
    <Tag
      rounded="full"
      variant="outline"
      colorScheme={colorScheme}
      textAlign="center"
      fontSize="12px"
    >
      {children}
    </Tag>
  );
}
